import { IExperience } from '../interfaces/IExperience';

export const experienceData: IExperience[] = [
    {
        role: "App Dev - Cloud Consultant",
        location: "Herndon, VA",
        businessName: "Amazon Web Services",
        date: "Jan 2025 - Present",
        description: "Building and maintaining applications built with AWS. Working closely in a team environment while juggling multiple hats across multiple teams. Implementing best practices and gaining experience with a diverse set of projects.",
        technologies: ["AWS", "TypeScript", "Python", "HTML & CSS", "React"],
        url: "https://aws.amazon.com/",
    },
    {
        role: "Cloud Consultant Intern",
        location: "Herndon, VA",
        businessName: "Amazon Web Services",
        date: "May 2024 - Aug 2024",
        description: "Implemented infrastructure and connections to multiple AWS Services to build out a search engine. Designed an architecture diagram and led team workflow/development processes and schedule. Developed re-usability, CI/CD, and portability of a product after meeting core deliverables. Aligned separate teammate’s pieces of work and mentored software development design and best practices. Presented to an audience of varying technical backgrounds.",
        technologies: ["AWS", "Python", "GitLab CI/CD"],
        url: "https://aws.amazon.com/",
    },
    {
        role: "Cloud Engineer/Software Development Co-op",
        location: "Malvern, PA",
        businessName: "Vanguard",
        date: "Sep 2023 - Dec 2023",
        description: "Using AWS Lambda and other cloud services to develop full stack solutions. Engineered a YAML duplicate key checker to prevent developer mistakes during a build, saving about 20+ hours of debugging plus platform support a week, backed by behavioral driven testing. Brainstormed a language agnostic solution to query JSON files for future platform tools. Developed an end-to-end, internal Python library to cut down thousands LOC of duplicated logic.",
        technologies: ["AWS", "Python", "PyTest", "Cucumber Testing"],
        url: "https://investor.vanguard.com/corporate-portal",
    },
    {
        role: "Software Engineer Intern",
        location: "Buffalo, NY",
        businessName: "M&T Bank",
        date: "June 2023 - Aug 2023",
        description: "Designed and developed a centralized hub with Angular/Spring Boot to hold internal bank applications. Built authentication and authorization microservice with Azure AD/LDAP and connection to a SQL database. Reduced tech debt by optimizing a web form and connected over 90 form entries to database endpoints. Iterated through a full production cycle: design document, development, testing, user feedback, deployment.",
        technologies: ["Java", "Springboot", "Angular", "TypeScript", "HTML & CSS", "SQL"],
        url: "https://www.mtb.com/careers/technology-internship-program",
    },
    {
        role: "Undergraduate Research Assistant",
        location: "Rochester, NY",
        businessName: "RIT, Biomedical Engineering Department",
        date: "Apr 2023 - Jul 2023",
        description: "Sole developer on an interactive experience with a Zenbo to be an emotional support robot that will perform surveys on patients while collecting basic biomedical health data using Android Studio and its Java SDK. Created 5 user interfaces consisting of multi-select options, radio buttons, and sliders",
        technologies: ["Kotlin", "Android Studio"],
        url: "https://www.rit.edu/engineering/bme",
    },
    {
        role: "Computer Science Homework Grader",
        location: "Rochester, NY",
        businessName: "RIT, Computer Science Department",
        date: "Aug 2022 - Dec 2022",
        description: "Prepared weekly Python scripts and grading scales to automate the grading of 47 students’ homework assignments in the course Computational Thinking/Problem Solving (Python). Boosted my ability to give effective and detailed feedback and ability to explain technical concepts",
        technologies: ["Python"],
        url: "https://www.rit.edu/computing/department-computer-science",
    },
    {
        role: "Computational Physicist Research Intern",
        location: "Medford, MA",
        businessName: "Tufts University",
        date: "Aug 2022 - Dec 2022",
        description: "Worked within a team of 5 developers and 8 polymer researchers to simulate the wetting phenomena through a replicated contact angle experiment by developing a shape optimization program using Morpho Presented my theoretical results and program to a group of 30, made up of the Tufts Polymer Research Team, chemical research professors, and graduate student researchers.",
        technologies: ["Python", "C"],
        url: "https://sites.tufts.edu/softmattertheory/",
    },
];
